
export class sideMenuIcon{

   home:any = '../../../assets/img/side-bar/home.svg';
   insight:any = '../../../assets/img/side-bar/insight.svg';
   user:any = '../../../assets/img/side-bar/users.svg';
   group:any = '../../../assets/img/side-bar/group.svg';
   data_template : any = '../../../assets/img/side-bar/data-template.svg';
   test_bank : any = '../../../assets/img/side-bar/test_bank.svg';
   rubric : any = '../../../assets/img/side-bar/rubric.svg';
   publish : any = '../../../assets/img/side-bar/publish.svg';
   schedule : any = '../../../assets/img/side-bar/schedule.svg';
   result : any = '../../../assets/img/side-bar/result.svg';
   item : any = '../../../assets/img/side-bar/item.svg';
   draft : any = '../../../assets/img/side-bar/draft.svg';
   tags : any = '../../../assets/img/side-bar/tags.svg';
   responses : any = '../../../assets/img/side-bar/responses.svg';
   upcoming_test : any = '../../../assets/img/side-bar/upcoming_test.svg';
   test_history : any = '../../../assets/img/side-bar/test_history.svg';

   selectedIcon : any = '../../../assets/img/side-bar/selected-icon/'
}


// WEBPACK FOOTER //
// ./src/app/application/model/side-menu.model.ts